<template>
    <AppModal ref="editProductFiltersModal" :title="$t('labels.edit_product_filters')">
        <div class="modal-body">
            <div class="d-flex mb-3">
                <img :src="product.picture_url ?? PLACEHOLDER_IMAGE_URL" alt="Product Image" class="image-item mr-2"/>
                <div class="text-container">
                    <span class="d-block text-nowrap text-bigger font-weight-bold" :title="product.name">{{ product.name }}</span>
                    <span class="text-muted text-smaller d-block">SKU: {{ product.sku }}</span>
                </div>
            </div>
            <FormGroup :label="filterItems[0].integration_filter.name" v-for="(filterItems, filterUuid) in product.filters">
                <AppAutoComplete
                    v-if="!product.filters[filterUuid][0].integration_filter.is_multiple"
                    :url="`/projects/${$route.params.projectUuid}/pim/channels/${$route.params.integrationUuid}/filter-items`"
                    :model-value="product.filters[filterUuid][0].uuid"
                    :selected-value="product.filters[filterUuid][0].name"
                    @update:model-value="selectFilterItem(filterUuid, $event)"
                    :query-params="{
                        integration_filter_uuids: [filterUuid]
                    }"
                />
                <MultiAutoComplete
                    v-else
                    :url="`/projects/${$route.params.projectUuid}/pim/channels/${$route.params.integrationUuid}/filter-items`"
                    v-model="product.filters[filterUuid]"
                    :query-params="{
                        integration_filter_uuids: [filterUuid]
                    }"
                />
            </FormGroup>
        </div>
        <div class="modal-footer d-flex justify-content-end">
            <AppButton size="sm" @click="saveFilters" color="indigo">
                {{ $t('buttons.save') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import MultiAutoComplete from '../../../../components/new/form/autocomplete/MultiAutoComplete.vue';

import { httpClient } from '../../../../services/HttpClient';
import { PLACEHOLDER_IMAGE_URL } from '../../../../constants';

export default {
    name: "EditProductFiltersModal",
    components: {
        AppModal, FormGroup, AppAutoComplete, AppButton, MultiAutoComplete
    },
    emits: ['product-filters-updated'],
    data() {
        return {
            product: null
        }
    },
    methods: {
        async show(product) {
            this.product = JSON.parse(JSON.stringify(product));

            this.$refs.editProductFiltersModal.show();
        },
        selectFilterItem(filterUuid, filterItem) {
            this.product.filters[filterUuid] = [filterItem];
        },
        async saveFilters() {
            await httpClient.patch(`/integrations/products/${this.product.uuid}`, {
                filter_item_uuids: Object.values(this.product.filters).flat().map(item => item.uuid)
            });

            this.$emit('product-filters-updated');
            this.$refs.editProductFiltersModal.hide();
            this.product = null;
        }
    }
}
</script>
<style scoped>
.image-item {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
}
.text-container {
    min-width: 0;
    overflow: hidden;
    flex: 1;
}
.text-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-bigger {
    font-size: 14px;
    line-height: 24px;
}
.text-smaller {
    font-size: 12px;
    line-height: 18px;
}
</style>